import { getDocumentation } from "./webdsl/documentation.js";

import logoLight from "../assets/dsls-logos/webdsl_L.png";
import logoDark from "../assets/dsls-logos/webdsl_D.png";
import { Typography } from "@mui/material";

/**
 * Retrieves the constants for the XmasDSL.
 * @returns {Promise<Object>} The constants for the XmasDSL.
 */
export const getWebdslConstants = async () => {
	const constants = {
		enabled: true,
		_id: "webdsl",
		name: "WebDSL",
		short: "webdsl",
		description: "WebDSL is an external Domain-Specific Language (DSL) designed for generating full-stack applications. It integrates multiple data sources, including databases, message brokers, and REST APIs, while also supporting static components. ",
		logoUrl: logoLight,
		logoUrlDark: logoDark,
		insertableEntities: {},
		shortDescription: await getDocumentation(),
		documentation: await getDocumentation(),
		subtypes: [],
		hasValidation: true,
		type: "Textual",
		canTransformTo: [],
		mustImport: [],
		canImport: [],
		supportsGeneration: true,
		supportsDeployment: true,
		deploymentStoppable: false,
		generationLanguage: "",
		generations: ["Default"],
		generationsOutputMap: {
			Default: "file",
		},
		keywords: [
			"row",
			"endrow",
			"col",
			"endcol",
			"Component",
			"Entity",
			"Webpage",
			"API",
			"Websocket",
			"Broker",
			"BrokerTopic",
			"end",
			"Screen",
			"Database",
			"RESTApi",
			"MySQLQuery",
			"MongoDBQuery",
			"RESTEndpoint",
		],
		llmSupport: false,
		tags: ["Full stack", "Textual"],
		initiallyCollapsed: false,
		experimental: true,
		deploymentInstructions: (
			<>
				<Typography color="white" sx={{ mb: 2, fontSize: "1.1rem" }}>
					{"You are about to deploy this model. Please follow the instructions below: "}
				</Typography>
				<Typography color="white" sx={{ fontSize: "1.1rem" }}>
					{"After clicking 'Deploy', check the output information on the right column."}
				</Typography>
				<Typography color="white" sx={{ mt: 2, fontSize: "1.1rem" }}>
					{"You will find the URL, along with a unique username and password, which you will have to enter in order to access the deployed application."}
				</Typography>
				<Typography color="white" sx={{ mt: 2, fontSize: "1.1rem" }}>
					{"It might take a few minutes to deploy the application. Please be patient."}
				</Typography>
			</>
		),
	};
	return constants;
};
